module.exports = __webpack_public_path__ + "static/media/32_tn.372d2a34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/32_tn.jpg
// module id = 170
// module chunks = 0